import React from "react"

const FlagRu = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><defs><clipPath id="ru-clip"><rect x="1" y="4" width="30" height="24" rx="4" ry="4"/></clipPath></defs><g clipPath="url(#ru-clip)"><rect x="1" y="4" width="30" height="8" fill="#fff"></rect><rect x="1" y="12" width="30" height="8" fill="#0039A6"></rect><rect x="1" y="20" width="30" height="8" fill="#D52B1E"></rect></g><path d="M27,4H5C2.791,4,1,5.791,1,8V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8C31,5.791,29.209,4,27,4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path></svg>
  )
}

export default FlagRu
